export default function Footer() {
  return (
    <footer className="bg-black border-t border-[#D4AF37]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16">
          {/* Column 1 - Brand */}
          <div className="md:col-span-5 text-center md:text-left">
            <img
              src="https://static.readdy.ai/image/7ce29a8f289d24a52677c0daf40c6c66/b23f9805b1736b70d397672c73928a82.png"
              alt="Barem Eventos"
              className="h-20 md:h-24 w-auto mb-6 md:mb-8 mx-auto md:mx-0"
            />
            <p className="text-sm font-light text-[#999999] italic mb-6 md:mb-10">
              Coquetelaria que eleva experiências
            </p>
            <p className="text-sm text-[#D4AF37]">
              Atendimento em todo Brasil
            </p>
          </div>

          {/* Column 2 - Contact */}
          <div className="md:col-span-3 text-center md:text-left">
            <h4 className="text-[#D4AF37] text-xs uppercase tracking-[0.15em] mb-6 md:mb-8">
              Contato
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:contato@baremeventos.com.br"
                  className="text-white text-sm hover:text-[#D4AF37] transition-colors duration-300 cursor-pointer"
                >
                  contato@baremeventos.com.br
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/5562985101348"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-white text-sm hover:text-[#D4AF37] transition-colors duration-300 inline-flex items-center cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  +55 62 98510-1348
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Social */}
          <div className="md:col-span-4 text-center md:text-left">
            <h4 className="text-[#D4AF37] text-xs uppercase tracking-[0.15em] mb-6 md:mb-8">
              Redes Sociais
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="https://instagram.com/baremeventos"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-white text-sm hover:text-[#D4AF37] transition-colors duration-300 inline-flex items-center cursor-pointer"
                >
                  <i className="ri-instagram-line mr-2 text-base"></i>
                  @baremeventos
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#D4AF37]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 md:py-10">
          <p className="text-center text-xs text-[#666666]">
            © 2025 Barem Eventos. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}